<template>
    <div>
        <button v-if="!processing" type="button" class="btn btn-sm btn-outline-theme d-flex" @click="getUsers">
            <i class="bi bi-arrow-down-circle pe-1 d-none d-md-block d-lg-block d-xl-block me-1"></i>Reports
        </button>
        <button v-else type="button" class="btn btn-sm btn-outline-theme disabled d-flex" disabled>
            <span class="spinner-border spinner-border-sm d-none d-md-block d-lg-block d-xl-block me-1" role="status" aria-hidden="true"></span>
            Processing...
        </button>
    </div>
</template>

<script>
import { appMixin } from '../../mixin/appMixin';
export default {
    name: 'CustomerReports',
    mixins: [appMixin],
    props: {
        userId: {
            type: Number,
            default: null
        },
        reportType: {
            type: String,
            default: 'customer' // customer, properties, recurring_services
        }
    },
    data() {
        return {
            processing: false,
            users: []
        }
    },
    mounted() {
        
    },
    methods: {
        getUsers() {
            this.processing = true;

            axios.post(`${this.$baseUrl}/api/admin/users/report`, {
                user_id: this.userId
            })
                .then(response => {
                    this.processing = false;
                    this.users = response.data.users;
                    this.$nextTick(() => {
                        this.downloadCustomerReport();
                    });
                })
                .catch(error => {
                    this.processing = false;
                });
        },
        downloadCustomerReport() {
            const headers = [
                'Name',
                'Email',
                'Phone',
                'Customer Type',
                'Properties',
                'Created At',
            ];

            // Create CSV content in chunks
            const chunkSize = 1000; // Process 1000 rows at a time
            let csvContent = headers.join(',') + '\n';

            for (let i = 0; i < this.users.length; i += chunkSize) {
                const chunk = this.users.slice(i, i + chunkSize);
                csvContent += chunk.map(user => {
                    return [
                        `"${user?.handymans?.map(h => h.name).join(', ') || ''}"`,
                        `"${user.name || ''}"`,
                        `"${user.phone_number || ''}"`,
                        `"${user.account_type || ''}"`,
                        `"${user?.addresses?.map(p => p.full_address).join('\n') || ''}"`,
                        `"${this.dataTimeFormat(user.created_at, 'YYYY-MM-DD') || ''}"`,
                    ].join(',');
                }).join('\n') + '\n';
            }

            // Create and trigger download
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'reports.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
</script>
